export default async function appStoreUpdateCheck() {}
